'use client';

import { useState } from 'react';
import { IconButton, Snackbar, SnackbarContent } from '@mui/material';
import { createPortal } from 'react-dom';

import ShareIcon from '@mui/icons-material/Share';
import CheckIcon from '@mui/icons-material/Check';

const CopyLinkButton = ({ url }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const portalRoot = document.getElementById('portal-root');

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url).then(() => {
      setSnackbarOpen(true);
    }).catch(() => {
      console.log("Failed to copy");
    });
  };
  const handleSnackbarClose = () => setSnackbarOpen(false);

  return (
    <>
      <IconButton onClick={handleCopyLink} aria-label="Copy link">
        <ShareIcon />
      </IconButton>

      {createPortal(
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          action={
            <IconButton onClick={handleSnackbarClose} color="inherit">
              <CheckIcon />
            </IconButton>
          }
        >
          <SnackbarContent
            sx={{ bgcolor: 'success.main', color: 'white' }}
            message="Link copied to clipboard!"
          />
        </Snackbar>, portalRoot
      )}
    </>
  );
};

export default CopyLinkButton;